/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '@/components/logo';

export default function B2bFooter(): ReactElement {
    const { t } = useTranslation('footer');
    const year = new Date().getFullYear();

    return (
        <footer
            className="mt-auto bg-footer-background text-footer-foreground [--header-logo-filter:var(--header-transparent-logo-filter)]"
            data-testid="b2b-footer">
            <div className="flex items-center justify-between gap-4 px-5 pt-5 pb-6">
                <div className="flex flex-col text-base leading-none [&_p]:m-0">
                    <p>{t('b2b.confidential')}</p>
                    <p>{t('b2b.copyright', { year })}</p>
                </div>
                <Logo
                    alt={t('b2b.logoAlt')}
                    className="h-6 w-auto shrink-0"
                    style={{ filter: 'var(--header-logo-filter)' }}
                />
            </div>
        </footer>
    );
}
